// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles__logo--3wNgP","logoIcon":"styles__logoIcon--E5Z25"};
    if(module.hot) {
      // 1541451120778
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  